<!-- SLOTS REQUIRED: -->
<!-- username, post-avatar, post-title, post-body, time -->

<template lang="html">
  <v-container>
    <v-card class="py-lg-5 px-lg-7 py-2 px-2">

      <v-row class="d-flex align-center mt-n2 mb-n6">

        <v-spacer></v-spacer>


        <span class="caption mx-1 grey--text text--darken2">
          <v-icon small class="mr-1">mdi-clock-outline</v-icon>
          <slot name="time">time-left</slot>
        </span>

        <v-btn icon><v-icon>mdi-dots-horizontal</v-icon></v-btn>
      </v-row>

      <!-- avatar top row -->
      <v-row class="d-flex align-center text-start">
        <v-col lg="1" cols="1" class="mr-lg-2 mr-8">
          <v-avatar>
            <slot name="post-avatar">
              <v-icon>mdi-waves</v-icon>
            </slot>
          </v-avatar>

        </v-col>
        <v-col lg="6" cols="6">
          <h3><slot name="username">first-last</slot></h3>
        </v-col>

      </v-row>

      <!-- text post -->
      <v-row>
        <v-card-title>
          <slot name="post-title">title</slot>
        </v-card-title>
      </v-row>

      <div class="post-img mb-5">
        <slot name="post-img"></slot>
      </div>

      <v-row>
        <v-card-text class="mx-4">
          <p><slot name="post-body">post-body</slot></p>
        </v-card-text>
      </v-row>

      <v-row class="ml-1">
        <slot name="button"><v-btn icon><v-icon>mdi-waves</v-icon></v-btn></slot>
      </v-row>


    </v-card>
  </v-container>

</template>

<script>
export default {
  // props: ['src'],
  // data () {
  //   return {
  //     srcP: this.src
  //   }
  // }
}
</script>

<style lang="css" scoped>
  .post-img {
    background-color: #FAFAFA; /* lightGrey */
  }
</style>
